import _ from "lodash";
import { Avatar, IconButton, Modal } from "@toddle-edu/ds-web";
import { CloseOutlined } from "@toddle-edu/ds-icons";
import React from "react";
import UIModal from "UIComponents/UIModal";
import I18nHOC from "UIComponents/I18nHOC";
import classes from "./PostSharedWithModal.scss";
import StudentAlerts from "AppComponents/StudentAlerts";
import { AVATAR_COLORS } from "Constants/colorConstants";
import {
  getFormattedUserNameWithoutPronoun,
  getSharedWithStringV2,
} from "Post/utils";
import classNames from "classnames";
import { compose } from "lib/apolloClient";
import { connect } from "react-redux";
import { hashString } from "Utils";
import { getDefaultStudentNameOrderPreference } from "modules/CommonSelectors";
import { getFormattedUserName } from "Utils/GetFormattedUserName";

const TaggedStudent = props => {
  const { student, isDsV2 = false } = props;

  const { id, alertTypes = [] } = student;

  return (
    <div tabIndex={0} className={classes.taggedStudentContainer}>
      <Avatar
        size={"small"}
        // iconType={"individual"} // Removing this as we need to show the user name in avatar
        color={AVATAR_COLORS[hashString(student?.id) % AVATAR_COLORS.length]}
        src={student.profileImage}
        shade={"light"}
        dsVersion={isDsV2 ? "2.0" : "1.0"}
        name={getFormattedUserNameWithoutPronoun({ user: student })}
      />
      <div className={classes.studentNameContainer}>
        <div
          className={
            isDsV2
              ? classes.taggedStudentNameTextV2
              : classes.taggedStudentNameText
          }
          data-test-id="journal-feed-postcard-sharedwithstudent"
        >
          {getFormattedUserName({
            user: student,
          })}
        </div>
        <StudentAlerts studentId={id} alertTypes={alertTypes} />
      </div>
    </div>
  );
};

const PostSharedWithModal = props => {
  const {
    isModalOpen,
    closeSharingModal,
    post,
    taggedStudents,
    isPrivate,
    isHiddenFromStudents,
    t,
    defaultStudentNameOrderPreference,
    dsVersion = "1.0",
  } = props;

  const hasTaggedStudents = _.get(taggedStudents, "length", 0) > 0;
  const SharedWith = getSharedWithStringV2({ isPrivate, isHiddenFromStudents });
  const modalContainerClass = classNames({
    [classes.privateModalContainer]:
      isPrivate && isHiddenFromStudents && !hasTaggedStudents,
    [classes.modalContainer]: true,
  });

  const isDsV2 = dsVersion === "2.0";

  const getTagMessage = type => {
    switch (type) {
      case "everyone":
        return t("journal:tagged_students_and_families");
      case "student":
        return t("journal:tagged_students");
      case "family":
        return t("journal:tagged_families_only");
      case "private":
        return t("journal:private");
      default:
        return "";
    }
  };

  return isDsV2 ? (
    // code for DSv2 modal ds version 2.0
    <Modal
      dsVersion="2.0"
      isOpen={isModalOpen}
      onClose={closeSharingModal}
      width="480px"
      height="fit-content"
      headerSeparator={true}
      footerSeparator={true}
      isBodyScrollable={true}
    >
      <Modal.Header
        isClosable={true}
        title={t("common:audience")}
        subtitle={getTagMessage(SharedWith)}
        hasSeparator={true}
      />
      <Modal.Body>
        <div>
          {isPrivate && isHiddenFromStudents && (
            <div
              className={classes.privatePostMessage}
              data-test-id="journal-feed-postcard-sharedwithsubdescription"
            >
              {hasTaggedStudents
                ? t("journal:post_visible_to_teachers")
                : t("journal:post_visible_to_teachers_only")}
            </div>
          )}
          {hasTaggedStudents && (
            <div className={classes.taggedListContainerV2}>
              {_.map(taggedStudents, student => (
                <TaggedStudent
                  key={student.id}
                  student={student}
                  defaultStudentNameOrderPreference={
                    defaultStudentNameOrderPreference
                  }
                  isDsV2={isDsV2}
                />
              ))}
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  ) : (
    <UIModal isOpen={isModalOpen} modalContent={modalContainerClass}>
      <div className={classes.modalBodyContainer}>
        <div className={classes.modalHeaderContainer}>
          <div className={classes.shareWithTitle}>{t("common:audience")}</div>
          <IconButton
            icon={<CloseOutlined />}
            onClick={closeSharingModal}
            variant="plain"
            testId="journal-feed-postcard-sharedwithclose"
          />
        </div>

        <div className={classes.taggingTypeContainer}>
          <div
            className={classes.tagMessage}
            data-test-id="journal-feed-postcard-sharedwithdescription"
          >
            {getTagMessage(SharedWith)}
          </div>
        </div>

        {isPrivate && isHiddenFromStudents ? (
          <div
            className={classes.privatePostMessage}
            data-test-id="journal-feed-postcard-sharedwithsubdescription"
          >
            {hasTaggedStudents
              ? t("journal:post_visible_to_teachers")
              : t("journal:post_visible_to_teachers_only")}
          </div>
        ) : null}
        {hasTaggedStudents ? (
          <div className={classes.taggedListContainer}>
            {_.map(taggedStudents, student => (
              <TaggedStudent
                key={student.id}
                student={student}
                defaultStudentNameOrderPreference={
                  defaultStudentNameOrderPreference
                }
              />
            ))}
          </div>
        ) : null}
      </div>
    </UIModal>
  );
};

const mapStateToProps = (state, ownProps) => {
  const defaultStudentNameOrderPreference = getDefaultStudentNameOrderPreference(
    state
  );
  return {
    defaultStudentNameOrderPreference,
  };
};

export default compose(
  connect(mapStateToProps, null),
  I18nHOC({ resource: ["journal"] })
)(PostSharedWithModal);
